import React, { Component } from 'react'
import '../OnlineHelpPage.css'
import CloudDesktop_001 from './img/CloudDesktop_001.png'
import CloudDesktop_002 from './img/CloudDesktop_002.png'

export default class CloudDesktop extends Component {
  render() {
    return (
      <div className="main-window">
        <div className="main-window-title">云桌面功能</div>
        <div className="main-window-content">用户使用云桌面可远程操作虚拟机，申请虚拟机</div>
        <img src={CloudDesktop_001} className="main-window-img"></img>
        <img src={CloudDesktop_002} className="main-window-img"></img>
      </div>
    )
  }
}
